export const labelStyles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  }
}
